import { useState } from 'react';
import { all } from '@/api/doc/data-classification';
import { DataTable } from '@/components/ui/custom/data-table';
import { TablePagination } from '@/components/ui/custom/table-pagination';
import { useQuery } from '@tanstack/react-query';
import {
	ColumnFiltersState,
	getCoreRowModel,
	getFilteredRowModel,
	getPaginationRowModel,
	getSortedRowModel,
	SortingState,
	useReactTable,
	VisibilityState,
} from '@tanstack/react-table';

import { columns } from './columns';

export function DataClassificationTable() {
	const { data, isFetching } = useQuery({
		queryFn: () =>
			all({
				includeDeleted: true,
			}),
		queryKey: ['data-classifications'],
	});
	const [sorting, setSorting] = useState<SortingState>([]);
	const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
	const [columnVisibility, setColumnVisibility] = useState<VisibilityState>({});
	const [rowSelection, setRowSelection] = useState({});

	const table = useReactTable({
		data: data ?? [],
		columns: columns,
		onSortingChange: setSorting,
		onColumnFiltersChange: setColumnFilters,
		getCoreRowModel: getCoreRowModel(),
		getPaginationRowModel: getPaginationRowModel(),
		getSortedRowModel: getSortedRowModel(),
		getFilteredRowModel: getFilteredRowModel(),
		onColumnVisibilityChange: setColumnVisibility,
		onRowSelectionChange: setRowSelection,
		state: {
			sorting,
			columnFilters,
			columnVisibility,
			rowSelection,
		},
	});

	return (
		<div className="h-1/2 w-full">
			<DataTable
				table={table}
				isFetching={isFetching}
				noResultsMessage="No data classifications found."
			/>

			<TablePagination table={table} isFetching={isFetching} />
		</div>
	);
}
